import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function safeFormat(date: string | number | Date | null | undefined, formatStr: string, fallback = 'N/A'): string {
  if (!date) return fallback;
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
    if (!isValid(dateObj)) return fallback;
    return format(dateObj, formatStr);
  } catch {
    return fallback;
  }
}

export function safeDistanceToNow(date: string | number | Date | null | undefined, fallback = 'some time'): string {
  if (!date) return fallback;
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
    if (!isValid(dateObj)) return fallback;
    return formatDistanceToNow(dateObj);
  } catch {
    return fallback;
  }
}
